import { GraphQLFormattedError } from 'graphql'

export const isExpiredTokenError = (
  graphQLErrors: readonly GraphQLFormattedError[]
): boolean => {
  return graphQLErrors.some(({ extensions }) => {
    return extensions?.code === 'UNAUTHENTICATED'
  })
}
